import React from 'react'

const LockSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14.575 16.209'
    >
      <path
        id='lock-alt-svgrepo-com'
        d='M10.537,12.4v1.634M6.452,8.744c.385-.024.86-.024,1.471-.024h5.23c.611,0,1.086,0,1.471.024m-8.172,0a2.759,2.759,0,0,0-1.113.244,2.451,2.451,0,0,0-1.071,1.071A6.091,6.091,0,0,0,4,12.643v1.144a6.091,6.091,0,0,0,.267,2.584,2.451,2.451,0,0,0,1.071,1.071,6.09,6.09,0,0,0,2.584.267h5.23a6.09,6.09,0,0,0,2.584-.267,2.451,2.451,0,0,0,1.071-1.071,6.09,6.09,0,0,0,.267-2.584V12.643a6.09,6.09,0,0,0-.267-2.584,2.451,2.451,0,0,0-1.071-1.071,2.76,2.76,0,0,0-1.113-.244m-8.172,0V7.086a4.086,4.086,0,1,1,8.172,0V8.744'
        transform='translate(-3.25 -2.25)'
        fill='none'
        stroke='#cecece'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}

export default LockSvg
